<template>
  <div class="company">
    <div class="content" v-loading="loading">
      <div style="font-size: 18px">已加入企业</div>
      <div class="info" style="margin-top: 27px">
        <div class="company-item" v-for="(company, index) in companies" :key="index">
          <div class="logo">
            <img
              :src="company.logo ? company.logo : logo"
              style="max-height: 48px;max-width: 48px;margin-top: 0;margin-bottom: 0;"
            />
          </div>
          <div class="font-main" style="flex: auto">{{ company.name }}</div>
          <base-button type="text" @click="setCurCompany(company)">前往</base-button>
          <dropdown-menu
            :menu-list="[{ title: '离开企业', command: 'leaveCompany' }]"
            @click="handleCommand($event, company)"
            placement="bottom-end"
            style="margin-left: 10px;"
          >
            <span class="pointer">
              <i class="el-icon-more"></i>
            </span>
          </dropdown-menu>
        </div>
        <div class="company-item">
          <div class="add-company" @click="joinOrCreateCompany">
            <svg-icon icon-class="plus"></svg-icon>
          </div>
          <div class="font-main" style="flex: auto;color: #C0C4CC">加入/创建企业</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/UIComponents/Button"
import DropdownMenu from "@/components/UIComponents/DropdownMenu"
import { defaultLogo } from "~/data/static"
import * as companyApi from "@/api/userCenter/company"
import { getUnreadMessageCount } from "@/api/userCenter/message"
import { setUnreadMessageCount } from "@/store/actions"
import { leaveCompany } from "@/api/user"

export default {
  name: "Company",
  components: { BaseButton, DropdownMenu },
  computed: {
    curUser() {
      return this.$store.getters.userInfo
    }
  },
  data() {
    return {
      companies: [],
      loading: false,
      logo: defaultLogo
    }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh: function() {
      this.loading = true
      companyApi.getCurUserCompanies().then(res => {
        this.companies = res.data
        this.loading = false
      })
    },
    setCurCompany: function(company) {
      companyApi.setCurCompany(company.id).then(res => {
        this.$message({
          message: "设置成功",
          type: "success"
        })
        this.$router.replace({
          name: "home"
        })
        getUnreadMessageCount().then(count => {
          setUnreadMessageCount(count)
        })
      })
    },
    handleCommand(command, company) {
      switch (command) {
        case "leaveCompany":
          this.leaveCompany(company)
          break
      }
    },
    leaveCompany(company) {
      this.$confirm("此操作将永久离开此公司,请谨慎操作.是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        leaveCompany(company.id).then(() => {
          this.$message.success("操作成功")
          this.$router.push({ name: "selectCompany" })
        })
      })
    },
    joinOrCreateCompany() {
      this.$router.push({ name: "createOrJoin" })
    }
  }
}
</script>

<style lang="scss" scoped>
.company {
  .content {
    padding: 16px 40px 64px 40px;
  }
  .company-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 73px;
    &:not(:last-child) {
      border-bottom: 1px solid #e4e4e4;
    }
  }
  .logo {
    @include flex-center;
    overflow: hidden;
    box-sizing: border-box;
    width: 48px;
    height: 48px;
    border-radius: 6px;
    border: 1px solid rgb(220, 223, 230);
    margin-right: 18px;
  }
  .add-company {
    @include flex-center;
    box-sizing: border-box;
    width: 48px;
    height: 48px;
    background: rgba(234, 236, 241, 1);
    border-radius: 6px;
    margin-right: 18px;
    cursor: pointer;
    .svg-icon {
      font-size: 24px;
      color: #c0c4cc;
    }
  }
}
</style>

<style lang="scss"></style>
